var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from "@mui/material";
export default function WelcomePageSubheader(_a) {
    var isMobile = _a.isMobile;
    return (isMobile ? (_jsxs("div", __assign({ className: 'flex flex-col gap-2 items-center' }, { children: [_jsx(Typography, __assign({ className: 'text-dark-text text-xl' }, { children: "Clinically validated" })), _jsxs(Typography, __assign({ className: 'text-lg text-faux-black font-extrabold' }, { children: ["Check your hearing in ", _jsx("span", __assign({ className: 'text-dark-text' }, { children: "3 minutes" }))] }))] }))) : (_jsxs(Typography, __assign({ variant: "subhead", className: "text-xl font-semibold text-faux-black px-4" }, { children: ["Check your hearing in just ", _jsx("span", __assign({ className: 'text-dark-text' }, { children: "3 minutes with our clinically validated test." }))] }))));
}
